import Factory from '../utils/factory'
import Base from './base'

export default Factory({
  id: null,
  ...Base(),
  category: null,
})
